import React, { useState } from 'react';
import { Eye, Clock, Zap, Award, BadgeCheck, BarChart, Share2, CalendarCheck, FileText } from 'lucide-react';
import UserAvatar from '../dashboard/UserAvatar';
import { add_task_rating, task_log } from '../../../utils/talent_services';
import StarRatingComponent from './modal/StarRatingComponent';
import Modal_proyectos from '../../menus/Modal';
import { useNavigate } from 'react-router-dom';
// Importa los estilos de Bootstrap (asume que están disponibles en tu proyecto)

/**
 * Componente Tarjeta de Tarea (TaskCard) usando React y Bootstrap 5.
 *
 * NOTA: Para que este código funcione, debes tener Bootstrap 5 CSS y
 * los iconos de Lucide React instalados en tu proyecto.
 */
const Taskcard = ({ token, title, end_date, shortURL,
   strategy, vote_done, timing, qlty, task_id, duration, usr_name, usr_id, active, completed, onRefresh, onOpenStatistics }) => {
  // URL de imagen de perfil de ejemplo
  const [showVerifyModal,setShowVerifyModal] = useState(false);
  const navigate = useNavigate();  
  // CSS personalizado para detalles no cubiertos por clases de Bootstrap
  const customStyles = `
    .task-card-bs {
      border: none;
      box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15); /* Sombra más sutil de BS */
      transition: transform 0.3s ease-in-out;
    }
    .task-card-bs:hover {
      transform: scale(1.01);
    }
    .task-card-header-bs {
      background-color: #f8f9fa; /* Fondo gris claro */
      border-radius: 0.6rem 0.6rem 0 0;
    }
    .task-card-avatar-bs {
      width: 3rem;
      height: 3rem;
      border: 2px solid #ced4da;
      object-fit: cover;
      box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    }
    .task-card-footer-bs {
      border-top: 1px solid #eaf2faff;
      padding-top: 0.75rem;
      padding-bottom: 0.75rem;
    }
    .purple-icon-bs {
      color: #7c3aed; /* Púrpura */
      display: flex;
      align-items: center;
    }
    .purple-icon-bs svg {
      fill: #d8b4fe;
      stroke: #7c3aed;
    }
       @media (max-width: 576px) {
        .task-card-header-bs {
            padding: 1rem !important;
        }
    }
    .task-priority-active {
        background-color: #ffe9cdff; /* Fondo suave anaranjado */
        border-left: 5px solid #f97316; /* Borde de prioridad */
    }
    
    .task-priority-completed {
        background-color: #95fb81ff; /* Fondo suave anaranjado */
        border-left: 5px solid #00fc58ff; /* Borde de prioridad */
    }

    .task-item-ative {
            background-color: #ffebd0ff;
            border-radius: 0.5rem; 
            transition: box-shadow 0.15s ease-in-out;
    }
    .task-item-completed {
            background-color: #c8ffc2ff;
            border-radius: 0.5rem; 
            transition: box-shadow 0.15s ease-in-out;
    }
  
   
         
  `;

    const handleRate = (calidad, efectividad) => {
      fetch_add_vote(calidad, efectividad);
      
    }

     async function fetch_add_vote(calidad, efectividad) {
                 
                    const task_list = await add_task_rating(token,task_id, calidad, efectividad);
                    if (task_list==null){
                      navigate("/");
                    }else {
                        
                        if(task_list.includes("Duplicate")){
                          alert("Ya votaste por esta tarjeta");
                        }
                        setShowVerifyModal(false);
                        onRefresh();
                    }
                  
          };
          const handleShareTask = (taskId) => {
            const link = `${window.location.origin}/task_progress?task_id=${taskId}`;
            navigator.clipboard.writeText("Califica mi aporte para subir mi ranking: \n" + link).then(() => {
                alert('¡Link copiado al portapapeles!');
            }).catch(err => {
                console.error('Error al copiar el link:', err);
                alert('No se pudo copiar el link');
            });
        };

  const completionDateText = (() => {
    if (!end_date) {
      return null;
    }
    const parsedDate = new Date(end_date);

    if (Number.isNaN(parsedDate.getTime())) {
      return end_date;
    }

    return `${parsedDate.getDate()}-${parsedDate.getMonth() + 1}`;
  })();

  const truncatedStrategy = strategy && strategy.length > 10 
    ? `${strategy.substring(0, 30)}...` 
    : strategy;

  const handleCardClick = () => {
    if (onOpenStatistics) {
      onOpenStatistics(task_id);
    }
  };

  return (
    <div className="w-100 px-2">

      <Modal_proyectos isOpen={showVerifyModal} onClose={() => setShowVerifyModal(false)}
                               title="Verificar Tarea" >
                           
                              <StarRatingComponent  onSet={(calidad, efectividad) => handleRate(calidad, efectividad)}  onClose={(e) => {
                                
                                setShowVerifyModal(false);
              
                                }}
                            ></StarRatingComponent>
                           
                        </Modal_proyectos>

      {/* Estilos personalizados inyectados para ajustes finos */}
      <style>{customStyles}</style>

      <div
        className={` card task-card-bs rounded-3  mb-2 ${active ? 'task-priority-active' : completed ? 'task-priority-completed' : ''}`}
        onClick={handleCardClick}
        style={{ cursor: onOpenStatistics ? 'pointer' : 'default' }}
      >
        
        {/* Sección Superior del Contenido (Header) */}
        <div className=  {`task-card-header-bs d-flex align-items-start p-4  ${active ? 'task-item-ative' : completed ? 'task-item-completed' : ''}`}>
          
          {/* Título Principal */}
          <div className="flex-grow-1 pe-3 ">
            <p className=" fs-6 fw-normal mb-0" style={{ lineHeight: '1.1', fontSize: '1rem' }}>
              {title}
            </p>
          </div>
          
          {/* Avatar del Usuario */}
           <UserAvatar
                        key={usr_id } // Usar user.usr_id es mejor que el index si es posible
                        usr_id={usr_id}
                        usr_name={usr_name}
                        
                    />
        
        </div>

        {/* Sección Inferior / Footer con Estrategia y Metadata */}
        <div className="card-footer task-card-footer-bs bg-white d-flex justify-content-between align-items-center small flex-wrap">
          
          {/* Estrategia/Categoría */}
          <div className="d-flex align-items-center text-muted fw-normal mb-2 mb-sm-0">
            {shortURL ? (
              <a 
                href={shortURL} 
                target="_blank" 
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
                className="text-decoration-none text-muted hover-text-primary"
                style={{ cursor: 'pointer' }}
              >
                {truncatedStrategy}
              </a>
            ) : (
              <span>{truncatedStrategy}</span>
            )}
          </div>
          
          {/* Metadata de Vistas y Duración */}
          <div className="d-flex align-items-center gap-2 ms-auto">
            
            {/* Vistas (Icono de Ojo) TODO: Enel futuro servira para decir que la tarea esta in supervision de alguien

            <div className="d-flex align-items-center text-muted fw-normal mb-2 mb-sm-0">
              <Eye size={16} className="me-1" />
              <span className="font-monospace text-dark">{views}</span>
            </div>
        */}

            {completed  && vote_done!="1" && (
                <button
                    type="button"
                    className="btn btn-sm btn-outline-danger d-flex align-items-center"
                    onClick={(e) => {
                        e.stopPropagation();
                    
                        setShowVerifyModal(true);
                      }
                    }
                    // Asume que tienes una función 'handleValidate'
                >
                    {/* Opción 1: Icono de Certificación formal (Award) */}
                    <Award size={16} className="me-1" />
                    {/* Opción 2: Icono de Marca de Verificación simple (CheckCircle) */}
                    {/* <CheckCircle size={16} className="me-1" /> */}
                    Validar
                </button>
            )}
           {completed && timing && (
              <>
              <div className="d-flex align-items-center text-muted fw-normal mb-2 mb-sm-0">
              <Zap color="#0073d0ff" size={20}  className="me-1" />
                <span className="fw-semibold text-dark">{timing}</span>
              </div>

              <div className="d-flex align-items-center text-muted fw-normal mb-2 mb-sm-0">
              <BadgeCheck color="#efc700ff" size={20}  className="me-1" />
                <span className="fw-semibold text-dark">{qlty}</span>
              </div>

              </>
             )
            }
            {completed && completionDateText && (
              <div className="d-flex align-items-center text-muted fw-normal mb-2 mb-sm-0">
                <CalendarCheck color="#16a34a" size={20} className="me-1" />
                <span className="fw-semibold text-dark">{completionDateText}</span>
              </div>
            )}
             {/* Duración (Icono de Reloj) */}
              <div className="d-flex align-items-center text-muted fw-normal mb-2 mb-sm-0">
                <button
                    onClick={(e) => {
                      e.stopPropagation();
                      if (onOpenStatistics) {
                        onOpenStatistics(task_id);
                        return;
                      }
                      navigate(`/statistics?task_id=${task_id}`);
                    }}
                    className="btn p-0 border-0 bg-transparent me-2"
                    style={{ cursor: 'pointer' }}
                    title="Ver descripción"
                    aria-label="Ver descripción"
                  >
                    <FileText color="#6366f1" size={16} />
                  </button>
                <button
                    onClick={(e) => {
                      e.stopPropagation();
                      if (onOpenStatistics) {
                        onOpenStatistics(task_id);
                        return;
                      }
                      navigate(`/statistics?task_id=${task_id}`);
                    }}
                    className="btn p-0 border-0 bg-transparent me-2"
                    style={{ cursor: 'pointer' }}
                    aria-label="Ver estadísticas"
                  >
                    <BarChart color="#6366f1" size={16} />
                  </button>
                  <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleShareTask(task_id);
                  }}
                  className="btn p-0 border-0 bg-transparent me-2"
                  style={{ cursor: 'pointer' }}
                  aria-label="Compartir tarea"
                >
                  <Share2 color="#10b981" size={16} />
                </button>
                <Clock size={16} className="me-1" />
                <span className="fw-semibold text-dark">{duration}</span>
              </div>
           
            
          </div>
        </div>
      </div>
    </div>
  );
};


export default Taskcard;
